import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { take } from 'rxjs';
import { SearchService } from 'src/app/core/services/search.service';

@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss'],
})
export class PaginatorComponent implements OnInit {
  @Input() total!: number;
  @Input() maxSize: number = 8;
  @Input() rowsPerPage = 10;
  @Input() updateParams: boolean = true;
  @Input() currentPage = 1;
  @Output() paginationUpdated = new EventEmitter();
  @Input() optionsNumberOFRow = Array.from({ length: 10 }, (_, i) => (i + 1) * 10);
  isFirstFromNgb: boolean = true;
  isParamsChanged: boolean = false;

  constructor(
    private searchService: SearchService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    if (!this.updateParams) {
      return;
    }
    this.route.queryParams.pipe(take(1)).subscribe((params) => {
      if (params['page'] && params['length']) {
        this.currentPage = Number(params['page']);
        this.rowsPerPage = Number(params['length']);
        this.isParamsChanged = true;
      }
    });
  }

  setPageManually(page: number): void {
    if (page < 1) {
      page = 1;
    } else if (page > this.total) {
      page = this.total;
    }

    this.currentPage = page;
    this.handlePaginationChange(true);
  }

  handlePaginationChange(isFromNgb: boolean, page?: number): void {
    if (this.isParamsChanged && !isFromNgb) {
      return;
    }

    this.currentPage = page ?? this.currentPage ?? 1;
    const per_page = this.rowsPerPage ?? 10;

    if (!this.updateParams) {
      this.paginationUpdated.emit({ page: this.currentPage, per_page });
      return;
    }

    this.searchService.setPagination(this.currentPage, per_page);
  }
}
